module.exports = __webpack_public_path__ + "img/sistemas-bombeo (1).4c79a617.jpg";